<style lang="scss" scoped="">

  .order-list-item {
    cursor: pointer;
  }

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;

    .title {
      color: red;
    }
  }

  .is-flex {
    display: flex;
    align-items: center;
  }

  .advanced-query-form {
    > .el-row {
      margin-bottom: 10px;
    }
  }
</style>
<style lang="scss">
  .adjust-const-stock-detail {
    h3 {
      background: #fff;
      margin: 50px 0 0;
      padding: 5px;
      text-align: center;
    }

    .el-table__row {
      cursor: auto;
    }
  }
</style>
<template>
  <div class="order-page">
    <div class="container">
      <div class="opera-btn-group" :class="{up:!showSearch}">
        <div class="opera-icon">
           <span class="pull-left">
             库存调整历史查询
          </span>
          <span class="pull-right">
            <des-btn custom icon="plus" perm="bsp-stock-org-adjust-add" @click="addAdjust">新增库存调整</des-btn>
          </span>
        </div>
        <el-form class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="8">
              <oms-form-row :span="6" label="货品主档">
                <goods-select :remote-method="queryManageGoods" placeholder="请输入名称搜索货品主档"
                              v-model="searchWord.goodsId" :list="dhsGoodsList" @change="orgGoodsChange"></goods-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="批号" :span="5">
                <el-select v-model="searchWord.batchNumberId" filterable clearable remote
                           :remoteMethod="queryDhsBatchNumbers" placeholder="请输入批号名称搜索批号">
                  <el-option v-for="item in batchNumberList" :value="item.id" :key="item.id" :label="item.batchNumber">
                    {{ item.batchNumber }}
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="供货单位" :span="5">
                <el-select filterable remote placeholder="请输入名称搜索供货单位" :remote-method="queryFactoryList" :clearable="true"
                           v-model="searchWord.supplyManufacturersId" popperClass="good-selects"
                           @click.native.once="queryFactoryList('')">
                  <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in factoryList">
                    <div style="overflow: hidden">
                      <span class="pull-left" style="clear: right">{{org.name}}</span>
                    </div>
                    <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{org.manufacturerCode}}
                      </span>
                    </div>
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <oms-form-row label="物流中心" :span="6">
                <el-select filterable remote placeholder="请输入名称搜索物流中心"
                           :remote-method="queryLogisticsCenter" :clearable="true"
                           v-model="searchWord.logisticsCentreId" popperClass="good-selects"
                           @click.native.once="queryLogisticsCenter('')">
                  <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in logisticsCenter">
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="" :span="8">
                <el-button type="primary" native-type="submit" @click="searchInOrder">查询</el-button>
                <el-button native-type="reset" @click="resetSearchForm">重置</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="batches" class="header-list store no-pointer" border v-loading="loadingLog"
                :header-row-class-name="'headerClass'" :max-height="bodyHeight" style="width: 100%">
        <el-table-column prop="logisticsCentreName" label="物流中心" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="orgName" label="货主" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="goodsName" label="货品" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="supplyManufacturersName" label="供货单位" min-width="160" :sortable="true"></el-table-column>
        <el-table-column prop="batchNumber" label="批号" :sortable="true" width="110"></el-table-column>
        <el-table-column prop="availableCount" label="业务合格库存" :sortable="true" width="140"></el-table-column>
        <el-table-column prop="unqualifiedBizCount" label="业务不合格库存" :sortable="true" width="140"></el-table-column>
        <el-table-column prop="transitCount" label="在途库存" :sortable="true" width="100"></el-table-column>
        <el-table-column prop="qualifiedActualCount" label="实际合格库存" :sortable="true" width="120"></el-table-column>
        <el-table-column prop="unqualifiedActualCount" label="实际不合格库存" :sortable="true"
                         width="140"></el-table-column>
        <el-table-column prop="createTime" label="调整时间" :sortable="true" width="160">
          <template slot-scope="scope">
            <span>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createdByName" label="操作人" :sortable="true" width="100">
          <template slot-scope="scope">
            <span>{{scope.row.createdByName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="调整原因" width="150"></el-table-column>
      </el-table>

      <div class="text-center" v-show="pager.count>pager.pageSize && !loadingData">
        <el-pagination
          :total="pager.count" :pageSize="pager.pageSize"
          @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[pager.pageSize,20,50,100]" layout="sizes, prev, pager, next, jumper"
          :current-page="pager.currentPage">
        </el-pagination>
      </div>
    </div>
    <page-right :show="showDetailPart" @right-close="resetRightBox" :css="{'width':'1000px','padding':0}">
      <detail :currentItem="currentItem" @close="resetRightBox"></detail>
    </page-right>
  </div>
</template>
<script type="text/jsx">
  //  import order from '../../../tools/orderList';
  import detail from './detail.vue';
  import OmsRow from '@dtop/dtop-web-common/packages/row';
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    mixins: [MethodsMix],
    components: {
      OmsRow,
      detail
    },
    data() {
      return {
        loadingData: false,
        showSearch: true,
        showDetailPart: false,
        batches: [],
        filters: {
          batchNumberId: '',
          goodsId: '',
          warehouseId: '',
          showFlag: true,
          supplyManufacturersId: '',
          logisticsCentreId: ''
        },
        searchWord: {
          batchNumberId: '',
          goodsId: '',
          warehouseId: '',
          showFlag: true,
          supplyManufacturersId: '',
          logisticsCentreId: ''
        },
        factories: [], // 厂商列表
        orgList: [], // 货主列表,
        orgGoods: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 10
        },
        currentItemId: '',
        currentItem: {},
        totalInfo: {},
        statusTitle: [
          '已过期',
          '即将到期',
          '正常'
        ],
        statusType: [
          'danger',
          'warning',
          'primary'
        ],
        batchNumberList: [],
        warehouses: [],
        form: {
          availableCount: '',
          qualifiedCount: '',
          transitCount: '',
          unqualifiedCount: '',
          undeterminedCount: ''
        },
        doing: false,
        operateList: [],
        loadingLog: false
      };
    },
    computed: {
      bodyHeight: function () {
        let height = parseInt(this.$store.state.bodyHeight, 10);
        height = height - 110;
        return height;
      }
    },
    mounted() {
      this.queryOperateList(1);
    },
    methods: {
      formatHeader(h, col) {
        let property = col.column.property;
        let content = '';
        let title = '';
        switch (property) {
          case 'qualifiedCount': {
            content = '仓库内真实合格货品数量';
            title = '合格';
            break;
          }
          case 'unqualifiedCount': {
            content = '仓库内真实不合格货品数量';
            title = '不合格';
            break;
          }
          case 'transitCount': {
            content = '在运输中的货品数量';
            title = '在途库存';
            break;
          }
          case 'totalCount': {
            content = '用于计算资产';
            title = '库存总数';
            break;
          }
          case 'availableCount': {
            content = '用于出库订单的控制，表明可销售的数量';
            title = '合格';
            break;
          }
          case 'unqualifiedBizCount': {
            content = '用于不合格品退货订单控制';
            title = '不合格';
            break;
          }
          case 'undeterminedCount': {
            content = '仓库内质量状态待确定而不允许销售的库存数';
            title = '业务停销';
            break;
          }
        }
        return (
          <el-tooltip effect="dark" content={content} placement="top">
            <span>{title}</span>
          </el-tooltip>
        );
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.queryOperateList(1);
      },
      handleCurrentChange(val) {
        this.queryOperateList(val);
      },
      queryOperateList(pageNo) {
        this.pager.currentPage = pageNo;
        let params = Object.assign({
          pageNo: pageNo,
          pageSize: this.pager.pageSize,
        }, this.filters);
        this.loadingLog = true;
        this.$http.get('/bsp-stock/adjust/log', {params}).then(res => {
          this.loadingLog = false;
          this.batches = res.data.list;
          this.pager.count = res.data.count;
        });
      },
      showDetail(item) {
        this.currentItemId = item.id;
        this.currentItem = item;
        this.showDetailPart = true;
      },
      resetRightBox() {
        this.showDetailPart = false;
      },
      searchInOrder: function () {// 搜索
        Object.assign(this.filters, this.searchWord);
        this.queryOperateList(1)
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          batchNumberId: '',
          goodsId: '',
          supplyManufacturersId: '',
          logisticsCentreId: '',
          showFlag: true
        };
        Object.assign(this.searchWord, temp);
        Object.assign(this.filters, temp);
        this.queryOperateList(1)
      },
      orgGoodsChange(val) {
        this.searchWord.batchNumberId = '';
        this.batchNumberList = [];
        this.queryDhsBatchNumbers();
      },
      queryDhsBatchNumbers(val) {
        if (!this.searchWord.goodsId) {
          this.batchNumberList = [];
          this.$notify.info('请选择货品主档');
          return;
        }
        this.queryDhsBatchNumberList({
          keyWord: val,
          goodsId: this.searchWord.goodsId
        });
      },
      formatTime(date) {
        return date ? this.$moment(date).format('YYYY-MM-DD') : '';
      },
      addAdjust() {
        this.$router.push('/store/operate/adjust');
      }
    }
  };
</script>
